import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { API_URL } from '../../../../../config/constants';
import GenericCard from '../../../../GenericCard';
import hitTagMapper from '../../../helpers/hitTagMapper';
import type { SearchAllContentHit } from '../../../types';
import type { TagProps } from '../../../../Tag';

interface Props {
  hit: SearchAllContentHit;
  className: string;
}

const EXCLUDED_CONTENT_TYPE_LABELS = ['basic_page', 'detail_page', 'landing_page', 'overview_page'];

const SearchAllContentResultsGenericHit: React.FC<Props> = (props) => {
  const { hit, className } = props;

  const { t } = useTranslation();

  const tags = useMemo(() => {
    let themeTags: TagProps[] = [];
    let typeTags: TagProps[] = [];

    if (hit.parent_name?.[0]) {
      themeTags = hitTagMapper([hit.parent_name[0]], 'theme');
    }

    if (hit.theme?.[0]) {
      themeTags = hitTagMapper(hit.theme, 'theme');
    }

    if (hit.type?.[0] && !EXCLUDED_CONTENT_TYPE_LABELS.includes(hit.type[0])) {
      typeTags = hitTagMapper([t(`content_types.${hit.type[0]}`)], 'article-type');
    }

    if (hit.vid?.[0]) {
      const hitHasParent = hit.parent_uuid?.[0] !== undefined;
      typeTags = hitTagMapper([t(`taxonomy_term.${hit.vid[0]}.${hitHasParent ? 'child' : 'parent'}`)], 'article-type');
    }

    return themeTags.concat(typeTags);
  }, [hit.parent_name, hit.parent_uuid, hit.theme, hit.type, hit.vid, t]);

  return (
    <GenericCard
      className={className}
      title={hit.page_title?.[0] || hit.name?.[0]}
      tags={tags}
      subtitle={hit.body_summarized?.[0] || hit.description?.[0]}
      link={hit.url[0]}
      profile={{
        name: hit.author_full_name?.[0] || hit.contact_person_full_name?.[0],
        image: hit.author_profile_picture?.[0] || hit.contact_person_profile_picture?.[0],
      }}
      image={hit.image_svg_url ? `${API_URL}${hit.image_svg_url[0]}` : hit.image_style_uri?.[0]}
    />
  );
};

export default SearchAllContentResultsGenericHit;
